import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'activity-female-tai-chi-walking-v2': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2&exp=web_f_walking_senior_discount_popup~1&age=65
			paywall: {
				experiment: () =>
					import('@/modules/Paywall/instances/experiments/web_f_walking_senior_discount_popup/tai-chi-walking-f-v2'),
			},
		},
		'activity-female-walking': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-walking&exp=web_f_walking_senior_discount_popup~1&age=65
			paywall: {
				experiment: () =>
					import('@/modules/Paywall/instances/experiments/web_f_walking_senior_discount_popup/walking-f'),
			},
		},
	},
]

export default config
